import { render, staticRenderFns } from "./StaticDocumentPreview.vue?vue&type=template&id=a81f1844"
import script from "./StaticDocumentPreview.vue?vue&type=script&lang=js"
export * from "./StaticDocumentPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports